import { render, staticRenderFns } from "./OrdersFBMTableUser.vue?vue&type=template&id=812fad9e&scoped=true"
import script from "./OrdersFBMTableUser.vue?vue&type=script&lang=js"
export * from "./OrdersFBMTableUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "812fad9e",
  null
  
)

export default component.exports